import { E2NtableHeader } from '@/components/Table';
import { Table, TableBody, TableHead, TableRow } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { UmsatzPlanWerteTableRow } from './UmsatzPlanWerteTableRow';
import { AbsatzPlanWerteTableRow } from './AbsatzPlanWerteTableRow';
import { useStandortContext } from '@/features/standortContext/StandortContext';

// eslint-disable-next-line complexity
export function EditTable() {
  const { t } = useTranslation();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzplanungAnzeige: tagebuchAnzeige } =
    useTagebuchEinstellungen(standortId);

  const planLabel =
    tagebuchAnzeige === 'ABSATZ_PRODUKTIVITAET'
      ? t('domain.controlling.umsatzplanung.table.absatzPlan')
      : tagebuchAnzeige === 'UMSATZ_PRODUKTIVITAET'
        ? t('domain.controlling.umsatzplanung.table.umsatzPlan')
        : t('domain.controlling.umsatzplanung.table.absatzUmsatzPlan');

  return (
    <Table>
      <E2NtableHeader className="hover:[&_tr]:bg-transparent">
        <TableRow>
          <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-0">
            {planLabel}
          </TableHead>
          <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-4">
            {t('domain.controlling.umsatzplanung.table.prognose2')}
          </TableHead>
          <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-4">
            {t('domain.controlling.umsatzplanung.table.produktivitaet')}
          </TableHead>
          <TableHead className="text-xs normal-case font-semibold h-0 py-4 ps-4">
            {t('domain.controlling.umsatzplanung.table.zielstunden')}
          </TableHead>
        </TableRow>
      </E2NtableHeader>
      <TableBody className="[&_tr:last-child]:border-b">
        {(tagebuchAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' ||
          tagebuchAnzeige === 'UMSATZ_PRODUKTIVITAET') && (
          <UmsatzPlanWerteTableRow />
        )}
        {(tagebuchAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' ||
          tagebuchAnzeige === 'ABSATZ_PRODUKTIVITAET') && (
          <AbsatzPlanWerteTableRow />
        )}
      </TableBody>
    </Table>
  );
}
